import { cn } from '@/shared/utils';

import { EmptyUI, ErrorUI } from '@/components/ui/ErrorEmptyUI';
import LoadMore from '@/components/ui/loadMore';
import Loading from '@/components/ui/loading';

import BcCard from './bcCard';

const BcList = ({
  data,
  isLoading,
  onLoadMore,
  hasMore,
  isFetchingNextPage,
  isError,
  error,
  searchTerm,
}) => {
  if (isLoading)
    return (
      <section
        className={cn(
          'flex flex-col p-5 my-4 w-full bg-black/30 max-md:max-w-full',
          'text-center h-[calc(100vh/3)]',
          'justify-center items-center'
        )}
      >
        <Loading />
      </section>
    );

  if (isError)
    return (
      <section
        className={cn(
          'my-8 h-[calc(100vh/3)]',
          'flex justify-center items-center',
          'border border-white/20 rounded-sm p-4'
        )}
      >
        <ErrorUI
          error={error}
          onRetry={() => onLoadMore()}
          description={`${error.code} - ${error.message}`}
        />
      </section>
    );

  if (data?.length === 0) {
    const message = {
      title: searchTerm
        ? "We couldn't find bowling centers under that name"
        : 'No bowling centers near you',
      description: searchTerm
        ? 'Please check the search term and try again.'
        : 'Try searching for a different location.',
    };
    return (
      <section
        className={cn(
          'm-auto py-16 mx-auto',
          'flex justify-center items-center',
          'p-5 mt-4 w-full bg-black/30 max-md:max-w-full',
          'h-[calc(100vh/2)] gap-4 rounded-[10px]'
        )}
      >
        <EmptyUI hideImage {...message} />
      </section>
    );
  }

  return (
    <section className="flex flex-col p-5 w-full bg-black/30 max-md:max-w-full">
      <h2 className="text-lg font-semibold tracking-wider leading-6 text-green-400 max-md:max-w-full">
        All bowling centers
      </h2>
      <ul>
        {data?.map((bc) => (
          <li
            key={bc.uuid}
            className="border-b border-solid border-neutral-700/60 last:border-b-0"
          >
            <BcCard data={bc} />
          </li>
        ))}
      </ul>

      {hasMore && (
        <LoadMore onLoadMore={onLoadMore} isLoading={isFetchingNextPage} />
      )}
    </section>
  );
};

export default BcList;
